/**
 * Mémorise la page qu'un utilisateur voulait atteindre avant d'être renvoyé à la
 * connexion, et l'y ramène une fois identifié.
 *
 * POURQUOI CE DÉTOUR EXISTE.
 * Les courriels de mention pointent un message précis d'un dossier précis. Ouvert
 * depuis la boîte aux lettres, le lien arrive dans un onglet neuf : le jeton vit en
 * `sessionStorage`, propre à chaque contexte de navigation, l'application demande donc
 * de s'identifier. Sans mémorisation, l'agent atterrit sur le tableau de bord et doit
 * retrouver seul le dossier dont on lui parlait - ce qui annule l'intérêt du courriel.
 *
 * LE RACCOURCI ÉCARTÉ. Glisser un jeton d'authentification dans l'URL du courriel
 * supprimerait l'étape, au prix d'un identifiant de connexion en clair dans un message
 * qui se transfère, se journalise chez le fournisseur de messagerie et reste dans
 * l'historique du navigateur - donnant accès à des dossiers d'indemnisation nominatifs.
 * L'authentification est conservée ; c'est le retour qui est automatisé.
 *
 * `sessionStorage` et non `localStorage` : une destination oubliée doit expirer avec
 * l'onglet, sinon une connexion faite trois jours plus tard rouvrirait un dossier que
 * l'agent avait cessé de chercher.
 */

const CLE = 'retourApresConnexion';

const DEFAUT = '/dashboard';

/** Chemins qu'il ne sert à rien de mémoriser - on y retournerait en boucle. */
const IGNORES = ['/login', '/otp-verify', '/'];

export const memoriserDestination = (chemin) => {
  if (!chemin || IGNORES.includes(chemin)) return;
  // Chemin relatif uniquement : accepter une URL absolue transformerait ce mécanisme
  // en redirection ouverte, exploitable depuis n'importe quel lien vers /login.
  if (!chemin.startsWith('/') || chemin.startsWith('//')) return;
  sessionStorage.setItem(CLE, chemin);
};

/** Destination mémorisée, consommée au passage : elle ne doit servir qu'une fois. */
export const consommerDestination = () => {
  const chemin = sessionStorage.getItem(CLE);
  sessionStorage.removeItem(CLE);
  return chemin || DEFAUT;
};
